import { TOGGLE_TIME_FILTER_MENU } from './constants';

export function toggleTimeFilterMenu(value) {
  return {
    type: TOGGLE_TIME_FILTER_MENU,
    value,
  };
}
